export const formatEmailTemplate = (emailTemplate: string) =>
  emailTemplate.replaceAll('_', ' ');
